import consumer from "../consumer";
import CalculationStatus from "./calculation_status";
import NoticesView from "./views/notices_view";
import ReportSpinnerView from "./views/report_spinner_view";
import PositionRoundHandler from "./handlers/position_round_handler";
import CompletionHandler from "./handlers/completion_handler";
import { reloadWithCalculationFlash } from "./reload_with_flash";

const SAFETY_RELOAD_MS = 30000;

const isScoresPage = () =>
  window.location.href.includes(`/leagues/${gon.league_id}/scores`);

export default class CalculationsChannelController {
  constructor() {
    this.noticesView = new NoticesView();
    this.reportSpinnerView = new ReportSpinnerView();
    this.positionHandler = new PositionRoundHandler();
    this.completionHandler = new CompletionHandler();
    this.safetyReloadTimeoutId = null;
    this.subscription = null;
    this.subscribedLeagueId = null;
  }

  start() {
    if (!window.$) return;

    $(document).on("turbolinks:load", () => this.init());
    $(document).on("turbolinks:before-cache turbolinks:before-visit", () =>
      this.clearSafetyReload()
    );
  }

  init() {
    this.clearSafetyReload();

    if (!gon.league_id || gon.league_id === "") {
      this.unsubscribe();
      return;
    }

    this.positionHandler.syncFromWindow();
    this.completionHandler.reset();
    this.scheduleSafetyReload();
    this.subscribe();
  }

  clearSafetyReload() {
    if (this.safetyReloadTimeoutId == null) return;

    clearTimeout(this.safetyReloadTimeoutId);
    this.safetyReloadTimeoutId = null;
  }

  scheduleSafetyReload() {
    this.clearSafetyReload();
    if (!isScoresPage() || !this.reportSpinnerView.isVisible()) return;

    this.safetyReloadTimeoutId = setTimeout(() => {
      this.safetyReloadTimeoutId = null;
      if (window.stopCalculationAutoReload) return;
      if (!isScoresPage() || !this.reportSpinnerView.isVisible()) return;

      reloadWithCalculationFlash();
    }, SAFETY_RELOAD_MS);
  }

  unsubscribe() {
    if (!this.subscription) return;

    this.subscription.unsubscribe();
    this.subscription = null;
    this.subscribedLeagueId = null;
  }

  subscribe() {
    if (this.subscription && this.subscribedLeagueId === gon.league_id) return;

    this.unsubscribe();
    this.subscribedLeagueId = gon.league_id;
    this.subscription = consumer.subscriptions.create(
      { channel: "CalculationsChannel", league_id: gon.league_id },
      {
        received: (data) => this.onReceived(data),
      }
    );
  }

  onReceived(data) {
    const status = CalculationStatus.from(data);

    if (status.hasPendingRounds) {
      this.positionHandler.reset();
      this.completionHandler.reset();
    }

    this.reportSpinnerView.render(status);
    this.noticesView.render(status);
    this.positionHandler.handle(status);
    this.completionHandler.handle(status);

    if (status.pendingReports > 0) this.scheduleSafetyReload();
    else this.clearSafetyReload();
  }
}
